import { Component, h, Host } from '@stencil/core';
import { $$$ } from '../../../utils/utils';

@Component({
  tag: 'lilu-filter-wrapper',
  styleUrl: 'lilu-filter-wrapper.scss',
  shadow: true,
})
export class LiluFilterWrapper {

  componentDidLoad() {
    $$$('#show-results')[0].addEventListener('click', () => {
      $$$('#filter-modal')[0].close();
    });
  }

  render() {
    return (
      <Host>
        <div class="filter-wrapper">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
